import React from 'react';
import { ZoButton } from '@zonofi/zo-components/input/zo-button/zo-button';
import { TooltipRenderProps } from 'react-joyride';
import { arrowDirectionMap } from '../data/constants';
import { SVGS } from '@zonofi/zono-money-design-system';

export const TourToolip: React.FC<TooltipRenderProps> = ({
  step,
  primaryProps,
  tooltipProps,
  backProps,
  skipProps,
}) => {
  return (
    step?.content && (
      <div
        className={`tour-guide-popup-container ${
          !step?.data?.showBorder && step?.data?.tooltip && 'tooltip'
        }`}
        {...tooltipProps}
        style={{ maxWidth: step?.data?.maxWidth || '306px' }}
      >
        {!(step?.data?.tooltip && !step?.data?.showBorder) && (
          <div className="tour-guide-popup-container-border" />
        )}
        {step?.data?.step && step?.data?.totalSteps && (
          <div className="tour-guide-popup-container-header">
            <span className="primary-font-semibold tour-guide-popup-container-header-steps">
              STEP {step?.data?.step}/{step?.data?.totalSteps}
            </span>
          </div>
        )}
        {step?.content}
        {!step?.data?.tooltip && (
          <div
            className={`tour-guide-popup-container-button${step?.data?.goBack ? 's' : ''}`}
          >
            {step?.data?.goBack && (
              <span
                onClick={(e) => {
                  step?.data?.onBackClick(
                    e,
                    primaryProps,
                    backProps,
                    skipProps
                  );
                }}
                className="primary-font-semibold tour-guide-popup-container-buttons-secondary"
              >
                Back
              </span>
            )}
            <div
              className={`tour-guide-popup-container-buttons-group${
                step?.data?.tooltip ? '-toolip' : ''
              }`}
            >
              {step?.data?.buttonName !== 'Skip' && (
                <ZoButton
                  onClick={(e) => {
                    console.log('clicked on next step');
                    // primaryProps?.onClick(e);
                    step?.data?.onClick?.(
                      e,
                      primaryProps,
                      backProps,
                      skipProps
                    );
                  }}
                  className="primary-font-semibold tour-guide-popup-container-buttons-primary"
                  disabled={false}
                  label={
                    step?.data?.buttonName ? step?.data?.buttonName : 'Next'
                  }
                  style={{
                    padding: '12px 16px',
                    borderRadius: '4px',
                    fontSize: '14px',
                    lineHeight: '20px',
                    background: '#32A7E8',
                    color: '#FFFFFF',
                  }}
                  endIcon={
                    <SVGS.RightArrowComp
                      color="#ffffff"
                      width={20}
                      height={20}
                    />
                  }
                />
              )}
              {step?.data?.buttonName === 'Skip' && (
                <ZoButton
                  onClick={(e) => {
                    step?.data?.onSkipClick(
                      e,
                      primaryProps,
                      backProps,
                      skipProps
                    );
                  }}
                  className="primary-font-semibold tour-guide-popup-container-buttons-primary"
                  disabled={false}
                  label={'Skip'}
                  style={{
                    padding: '12px 16px',
                    fontSize: '14px',
                    background: 'transparent',
                    lineHeight: '20px',
                    color: '#32A7E8',
                  }}
                />
              )}
              {step?.data?.editButton && (
                <ZoButton
                  onClick={async (e) => {
                    await step?.data?.onEditClick(
                      e,
                      primaryProps,
                      backProps,
                      skipProps
                    );
                  }}
                  className="primary-font-semibold tour-guide-popup-container-buttons-primary"
                  disabled={false}
                  label={'Edit'}
                  style={{
                    padding: '12px 16px',
                    borderRadius: '4px',
                    fontSize: '14px',
                    lineHeight: '20px',
                    background: '#32A7E8',
                    color: '#FFFFFF',
                  }}
                  endIcon={
                    <SVGS.EditIconComp color="#ffffff" width={20} height={20} />
                  }
                />
              )}
            </div>
            {step?.data?.tooltipButton && step?.data?.tooltip && (
              <span
                onClick={(e) => {
                  step?.data?.onTooltipClick(
                    e,
                    primaryProps,
                    backProps,
                    skipProps
                  );
                }}
                className="primary-font-semibold tour-guide-popup-container-buttons-secondary"
              >
                {step?.data?.tooltipButton}
              </span>
            )}
          </div>
        )}
        {step?.data?.tooltipButton && (
          <span
            className="primary-font-semibold tour-guide-popup-container-buttons-tooltip"
            onClick={(e) =>
              step?.data?.onTooltipClick(e, primaryProps, backProps, skipProps)
            }
          >
            {step?.data?.tooltipButton}
          </span>
        )}
        {step?.data?.arrowDirection && (
          <div
            className="arrow-container"
            style={{ ...arrowDirectionMap[step?.data?.arrowDirection] }}
          />
        )}
      </div>
    )
  );
};
